module.exports = __webpack_public_path__ + "static/media/man-in-red-jacket-1681010.ba3f72b5.jpg";